

import { Map, Record } from 'immutable';

export interface CatalogLayoutState extends Map<string, any> {

  catalogCount: any;
  catalogCountLoading: boolean;
  catalogCountLoaded: boolean;
  catalogCountFailed: boolean;
}

export const CatalogLayoutStateRecord = Record({

  catalogCount: {},
  catalogCountLoading: false,
  catalogCountLoaded: false,
  catalogCountFailed: false,
});
